// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/mustererstellung/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const mustererstellungDE: PageEntry = {
  id: "post.mustererstellung",
  locale: "de",
  slug: "mustererstellung",
  seo: {
    title: "Glossar: Mustererstellung einfach erklärt | Dietz GmbH",
    description: "Mustererstellung ist der Prozess, bei dem physische Modelle oder Prototypen auf Grundlage von Musterdesigns und -entwicklungen hergestellt werden. Dieser Schritt ermöglicht es, das",
  },
  type: "post",
  h1: "Glossar: Mustererstellung einfach erklärt",
  intro: "Mustererstellung ist der Prozess, bei dem physische Modelle oder Prototypen auf Grundlage von Musterdesigns und -entwicklungen hergestellt werden. Dieser Schritt ermöglicht es, das Muster in der Realität zu testen, seine Funktionalität zu überprüfen und eventuelle Anpassungen vor der Massenproduktion vorzunehmen. Die Mustererstellung ist besonders wichtig in Bereichen wie der Textilindustrie, wo Kleidungsstücke vor der Produktion getestet werden, um Passform, Materialauswahl und Design zu optimieren. Ein effizienter Mustererstellungsprozess trägt zur Qualität und Effizienz bei.",
  blocks: [

  ],
};
